// extracted by mini-css-extract-plugin
module.exports = {"dndItemContainer":"style_dndItemContainer__CBSIF","dndContainer":"style_dndContainer__0Xu0i"};